import constants from "../utils/constants";
import TokenNeeded from "../utils/TokenNeeded";

class BalootUserControllerV3 {
  static walletTransactions(data) {
    return TokenNeeded.request({
      method: "get",
      url: constants.baloot.userControllerV3 + "wallets/transactions",
      params: data,
    });
  }
}

export default BalootUserControllerV3;
